import * as React from "react";
import SectionView from "../../layout/section/SectionView";
import Row from "../../layout/Row";
import Col from "../../layout/Col";
import AddressFormGroup from "../../address/form/component/AddressFormGroup";
import ContactFormGroup from "../../contacts/form/component/ContactFormGroup";
import MentionFormGroup from "../../ui/form/MentionFormGroup";
import SectionSeparator from "../../layout/section/SectionSeparator";
import SelectUsersFormGroup from "../../lead/form/SelectUsersFormGroup";
import JobType from "../jobType/JobType";
import {FormBodyProps} from "../../common/props/FormBodyProps";
import JobForm from "./JobForm";
import User from "../../../model/user/User";
import AgentSelectorFormGroup from "../../lead/form/AgentSelectorFormGroup";

type Props = FormBodyProps<JobForm>;

export default class AddJobFormBody extends React.Component<Props, {}> {

	render() {
		return (
			<React.Fragment>
				<SectionView>
					<Row>
						<Col xl={6} lg={6}>
							<AddressFormGroup label="Site"
											  field={this.props.form.address}
											  onChange={field => {
												  field.getOptionalValue().isDefined ? this.props.onFieldCompleted(field) :
													  this.props.onFieldChange(field)
											  }}
											  form={this.props.form}
											  onFocusChange={this.props.onFocusChange}/>
						</Col>
						<Col xl={6} lg={6}>
							<ContactFormGroup label="Primary contact"
											  field={this.props.form.principalContactId}
											  onChange={this.props.onFieldCompleted}
											  form={this.props.form}
											  onFocusChange={this.props.onFocusChange}/>
						</Col>
					</Row>
					<Row>
						<Col xl={6} lg={6}>
							<MentionFormGroup label="Description"
											  field={this.props.form.description}
											  onChange={this.props.onFieldChange}
											  form={this.props.form}/>
						</Col>
					</Row>
					{/* The field above already leaves its 30px under it. */}
					<SectionSeparator style={{margin: "0 -25px 30px"}}/>
					<Row>
						<Col xl={6} lg={6}>
							<SelectUsersFormGroup field={this.props.form.watchers}
												  onChange={this.props.onFieldChange}
												  label="Watchers"
												  placeholder="Watchers"
												  filterFunction={this.filterWatchers}/>
						</Col>
						<Col xl={6} lg={6}>
							<AgentSelectorFormGroup label={"Job Agent"}
													onChange={this.props.onFieldChange}
													field={this.props.form.agentId}/>
						</Col>
					</Row>
				</SectionView>
			</React.Fragment>
		)
	}

	filterWatchers = (user: User) => user.canBeWatcher();
}
